import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable } from "rxjs";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";

@Injectable({
  providedIn: "root",
})
export class GetUserConfigurationWS {
  constructor(private handler: BaseHandler) {}

  execute(token: string): Observable<any> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .setUrl(ApiUrls.GET_USER_CONFIGURATION_ENDPOINT())
      .build();

    return this.handler
      .execute(parameters)
  }
}
